import { Form } from "antd";
import React from "react";
import Input from "./BaseInput";
import AutoDismissToolTip from "@/components/AutoDismissToolTip";

interface ProductOriginalIdProps {
    disabled?: boolean;
}

const ProductOriginalId: React.FC<ProductOriginalIdProps> = (props) => {
    const { disabled } = props;

    return (
        <AutoDismissToolTip
            placement="top"
            title={
                <p>
                    1、商品ID最多可同时搜索10个
                    <br />
                    2、多个商品ID间可用逗号、换行、空格分隔
                </p>
            }
            trigger="click"
        >
            <Form.Item label={<span className="search-field-label">商品ID</span>} name="productOriginalIds">
                <Input disabled={disabled} allowClear />
            </Form.Item>
        </AutoDismissToolTip>
    );
};

export default React.memo(ProductOriginalId);
